import { render, staticRenderFns } from "./CallEnded.vue?vue&type=template&id=d901d4d6&"
import script from "./CallEnded.vue?vue&type=script&lang=js&"
export * from "./CallEnded.vue?vue&type=script&lang=js&"
import style0 from "./CallEnded.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports